import React, { useEffect } from "react";
import { MainContainer } from "../Components/Elements";
import PagesNav from "../Components/PagesNav";
import SearchInput from "../Components/SearchInput";
import AddInput from "../Components/AddInput";
import { Accordion } from "react-bootstrap";
import backBtn from "../assets/icons/backBtn.png";
import { Link } from "react-router-dom";
import AddPermissionHooks from "../hooks/MangmentHooks/AddPermissionHooks";
import MainInput from "../Components/MainInput";
import { useLocation } from "react-router-dom";

const AddPermissiongroup = () => {
  const location = useLocation();
  const existingPermissionGroup = location.state?.permission || null;

  const {
    NavItems,
    setSearch,
    selectedTeamName,
    handleShow,
    show,
    teams,
    handleClose,
    selectedOption,
    selectedTeamId,
    handleSelect,
    permissionGroup,
    handleChange,
    formatLabel,
    handleSubmit,
    handleNameChange,
    setPermissionGroup,
    loadingAdd,
    selectAll,
    handleSelectAllChange,
  } = AddPermissionHooks(existingPermissionGroup);

  return (
    <>
      <MainContainer>
        <div className="d-flex gap-3 mb-3 align-items-center">
          <PagesNav
            forceActive={"/management/permissiongroup/addpermissiongroup"}
            links={NavItems}
          />
          <div className="d-flex gap-2">
            <Link to={"/management/permissiongroup"}>
              <img src={backBtn} alt="backBtn" />
            </Link>
          </div>
        </div>

        <MainInput
          label={"Name*"}
          placeholder={"Enter permission group Name"}
          forceWidht
          value={permissionGroup.name}
          onChange={(e) =>
            setPermissionGroup({ ...permissionGroup, name: e.target.value })
          }
        />
 <div
            className="d-flex gap-2 align-items-center mt-3"
            style={{ width: "10%" }}
          >
            <input
              type="checkbox"
              id="selectAll"
              checked={selectAll}
              onChange={handleSelectAllChange}
            />
            <label htmlFor="selectAll" className="w-100">
              Select All
            </label>
          </div>
        <div>
          <p
            className="my-2 text-muted"
            style={{ fontSize: "15px", fontWeight: "bold" }}
          >
            Select Permissions*
          </p>
          <div className="row gy-2">
            {Object.keys(permissionGroup).map((key) => {
              // Exclude specific keys
              if (
                key !== "name" &&
                key !== "_id" &&
                key !== "createdAt" &&
                key !== "updatedAt"
              ) {
                return (
                  <div className="col-md-3" key={key}>
           
                   
                      <input
                        type="checkbox"
                        name={key}
                        id={key}
                        checked={permissionGroup[key]}
                        onChange={handleChange}
                        style={{marginRight:'4px'}}
                      />
                          <label htmlFor={key}>     {formatLabel(key)} </label>
                      {/* <span className="slider"></span> */}
                   
                  </div>
                );
              }
              return null;
            })}
          </div>

          <div className="mt-3 text-end">
            <button
              onClick={handleSubmit}
              className="btn bg-white text-main shadow-lg px-5 py-2 fw-bold"
            >
              {loadingAdd ? <i className="fa-solid fa-fan fa-spin fa-spin-reverse mx-3"></i> : "Submit"} 
              </button>
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default AddPermissiongroup;
